import { rosterAPI } from '@/providers/apis/roster/roster';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'roster-table-pullup',
})

export default class RosterTablePullup extends Vue {

    // ----------------------------------------------------------------------
    // Properties

    private pullupFields: any = [
        {
            label: 'Class Name',
            key: 'title',
            sortable: true,
        },
        {
            label: 'Class Type',
            key: 'classSharing',
        },
        {
            label: 'Subject',
            key: 'preference.subject',
        },
        {
            label: 'Grades',
            key: 'grades',
        },
        {
            label: 'Teacher',
            key: 'teacherCount',
        },
    ];

    private pullupData: any = [];

    private isLoading: boolean = false;

    @Prop()
    private selectedClass: any;

    @Prop()
    private selectedRow: any;


    // ------------------------------------------------------------------------------
    // Hooks


    private created() {
        this.fetchClassListByUserId();
    }


    // -------------------------------------------------------------------------------
    // Actions



    // ------------------------------------------------------------------------------
    // Methods

    private fetchClassListByUserId() {
        const sourcedId = this.selectedRow.id;
        const params = {
            sourcedId,
            parent_id: this.selectedClass,
        };
        this.isLoading = true;
        rosterAPI.getClassesDetails(params).then((classList: any) => {
            this.pullupData = classList.classes;
            this.isLoading = false;
        });
    }


    private arrayToString(value: any) {
        return value ? value.toString() : value;
    }



}
